import React from "react";
import { LINKS, LOGOS } from "@/constants/links";
import TapestryWeave from "@/components/TapestryWeave";
import { ArrowRight, MessageCircle } from "lucide-react";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative flex min-h-[100svh] flex-col justify-center overflow-hidden pt-32"
    >
      <TapestryWeave opacity={0.16} />
      {/* Ambient gold glow */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-40 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(201,168,124,0.10), transparent 70%)",
        }}
      />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 md:px-10">
        <div className="mx-auto max-w-4xl text-center">
          <img
            src={LOGOS.tapestryMark}
            alt="Tapestry Games"
            data-testid="hero-brand-mark"
            className="fade-up mx-auto h-24 w-auto md:h-32 lg:h-36"
          />

          <p
            data-testid="hero-eyebrow"
            className="eyebrow fade-up delay-1 mt-8"
          >
            Tapestry Games · Tabletop Role-Playing
          </p>

          <h1
            data-testid="hero-heading"
            className="font-serif-display track-in mt-6 text-5xl leading-[0.95] text-[#F2EFEB] sm:text-6xl lg:text-8xl"
          >
            Stories, <em className="italic text-[#C9A87C]">woven</em>
            <br />
            one thread at a time.
          </h1>

          <p
            data-testid="hero-subtitle"
            className="fade-up delay-2 mx-auto mt-10 max-w-2xl text-base leading-relaxed text-[#A39D95] sm:text-lg"
          >
            Tapestry Games is an independent studio crafting tabletop
            roleplaying games we call <em className="italic text-[#C9A87C]">Mythos</em> —
            stories set in a single urban hub or realm, where influence, fate,
            and power matter as much as any sword. Two Mythos are taking shape.
          </p>

          <div
            data-testid="hero-cta-row"
            className="fade-up delay-3 mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row"
          >
            <a
              href="#launch"
              data-testid="hero-cta-launch"
              className="btn-primary"
            >
              See the Launch <ArrowRight className="h-4 w-4" />
            </a>
            <a
              href={LINKS.discord}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-discord"
              className="btn-ghost"
            >
              <MessageCircle className="h-4 w-4" /> Join Discord
            </a>
          </div>

          {/* Tiny anchor row */}
          <div className="fade-up delay-4 mt-20 flex items-center justify-center gap-8 text-[10px] uppercase tracking-[0.32em] text-[#6E6A64]">
            <span>Two Games</span>
            <span className="h-px w-8 bg-[#C9A87C]/30" />
            <span>One Loom</span>
            <span className="h-px w-8 bg-[#C9A87C]/30" />
            <span>Endless Threads</span>
          </div>
        </div>
      </div>

      {/* bottom divider */}
      <div className="absolute inset-x-0 bottom-0">
        <div className="divider-thread" />
      </div>
    </section>
  );
};

export default Hero;
